export const ClassificationType = {
    WIKI_BASED: 1,
    VECTOR_BASED: 2
}